import type { TimelineRailRoundMarker } from '../../lib/timelineRailMarkers'
import type { ThemeId } from '../../theme/ThemeContext'

type Props = {
  marker: TimelineRailRoundMarker
  theme: ThemeId
}

/** 节点正上方：居中于中轴列，允许横向溢出窄轨宽（whitespace-nowrap） */
export function TimelineRailAxisLabels({ marker, theme }: Props) {
  const { labels, showYear, showMonthDay } = marker
  const { yearLabel, monthDayLabel } = labels

  if (!showYear && !showMonthDay) return null

  return (
    <div
      className="glyphicai-timeline-axis-labels flex w-max max-w-[min(10rem,calc(100vw-5rem))] flex-col items-center gap-0.5 text-center"
      aria-hidden
    >
      {showYear && yearLabel ? (
        <span
          className="glyphicai-timeline-year-art whitespace-nowrap leading-[1.05]"
          data-theme={theme}
        >
          {yearLabel}
        </span>
      ) : null}
      {showMonthDay && monthDayLabel ? (
        <span className="glyphicai-timeline-month-day whitespace-nowrap text-[11px] font-semibold leading-snug text-ink-soft sm:text-xs">
          {monthDayLabel}
        </span>
      ) : null}
    </div>
  )
}
